// extracted by mini-css-extract-plugin
module.exports = {"fileSelect":"Upload_fileSelect__3VUlH","videoButtons":"Upload_videoButtons__3-T0Y"};